/* sb-dc-standpocket.js - a banner stand needs pole pockets. 2026-10-09
   (theme "DC la", store's request).

   In the proof's "Add together" section the customer can tick a Banner stand.
   The stand hangs the backdrop by its pole pockets, so with a stand ticked the
   only finishings that work are the pole pocket ones (top and bottom / top
   only). If the customer ticked the stand with any other finishing - grommets,
   hem, none - this file:
     1. puts a red notice right under the stand row, with one button per pole
        pocket option the product offers (it switches the finishing for them)
        and the alternative of unticking the stand;
     2. stops the approve buttons in the proof footer (Approve & add to cart,
        and add-and-design-another) - the click is swallowed before React sees
        it, the notice flashes and scrolls into view;
     3. as a second line of defence, refuses window.__dcAddToCart while the
        combination is wrong.
   Untick the stand or switch to pole pockets and everything works as before.

   WHERE THE FACTS COME FROM
   - stand ticked: window.__dcAddons() (the add-on module's own list), with
     the checkbox in .sbdc-addon[data-key="banner-stand"] as a fallback.
   - finishing:   window.__dcApi.spec.finishing.
   - options:     the finishing card #sbdc-finrail (hidden by
                  sb-dc-findropdown.js but still in the page) - its
                  button[data-fin] list is exactly what this product offers.
   ⚠ Do NOT call window.__dcFinishingList() to ask which options exist: it
     snaps the current finishing to the first item of whatever list it is
     given (measured 2026-10-09 - a test call turned grommets-only into
     pockets-both). Reading the card has no side effects.

   SCOPE: only products that actually offer a pole pocket finishing. A product
   with no finishing card, or none of the pocket options (window decals,
   retractables, stickers, flags), is left alone - there would be nothing the
   customer could switch to, and blocking would make the stand impossible.

   The switch buttons click the card's own button, the same way the finishing
   dropdown does, so price, board drawing and every other rule stay where they
   were.

   Diagnostics: window.__dcStandPocket() */
(function () {
  'use strict';

  var NOTE_ID = 'sbdc-standpocket';
  var CSS_ID = 'sbdc-standpocket-css';
  var STAND = 'banner-stand';
  var POCKETS = ['pockets-both', 'pockets-top'];

  var info = { violated: false, stand: false, finishing: '', pocketOpts: [], blocked: 0, refusedAdd: 0 };
  window.__dcStandPocket = function () { return info; };

  /* ---- facts ------------------------------------------------------------ */

  function standTicked() {
    try {
      if (typeof window.__dcAddons === 'function') {
        var a = window.__dcAddons() || [];
        for (var i = 0; i < a.length; i++) if (a[i] && a[i].handle === STAND) return true;
        return false;
      }
    } catch (e) {}
    var cb = document.querySelector('.sbdc-addon[data-key="' + STAND + '"] input[type=checkbox]');
    return !!(cb && cb.checked);
  }

  function finishing() {
    try { return String((window.__dcApi && window.__dcApi.spec && window.__dcApi.spec.finishing) || ''); }
    catch (e) { return ''; }
  }

  /* Pole pocket options this product offers, with the card's own labels. */
  function pocketOptions() {
    var r = document.getElementById('sbdc-finrail');
    if (!r) return [];
    var out = [];
    POCKETS.forEach(function (id) {
      var b = r.querySelector('button[data-fin="' + id + '"]');
      if (!b) return;
      var lab = (b.querySelector('b') && b.querySelector('b').textContent) || id;
      out.push({ id: id, label: lab.replace(/\s+/g, ' ').trim(), btn: b });
    });
    return out;
  }

  function check() {
    var opts = pocketOptions();
    var fin = finishing();
    var stand = standTicked();
    info.stand = stand;
    info.finishing = fin;
    info.pocketOpts = opts.map(function (o) { return o.id; });
    info.violated = !!(stand && opts.length && POCKETS.indexOf(fin) < 0);
    return { bad: info.violated, opts: opts };
  }

  /* ---- the notice ------------------------------------------------------- */

  function css() {
    if (document.getElementById(CSS_ID)) return;
    var st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent =
      '#' + NOTE_ID + '{margin:10px 0 2px;padding:11px 13px;border:1.5px solid #E5484D;border-radius:10px;' +
      'background:#FFF4F4;color:#8B1A1E;font:400 12.5px/1.45 Arial,Helvetica,sans-serif}' +
      '#' + NOTE_ID + ' b{display:block;font-size:13px;font-weight:700;margin:0 0 3px;color:#B4232A}' +
      '#' + NOTE_ID + ' .sp-row{display:flex;flex-wrap:wrap;gap:6px;margin:8px 0 0}' +
      '#' + NOTE_ID + ' button{border:1px solid #B4232A;background:#fff;color:#B4232A;border-radius:999px;' +
      'padding:5px 11px;font:700 12px/1.2 Arial,Helvetica,sans-serif;cursor:pointer}' +
      '#' + NOTE_ID + ' button:hover{background:#B4232A;color:#fff}' +
      '#' + NOTE_ID + '.sp-flash{animation:sbdc-sp-flash .9s ease 2}' +
      '@keyframes sbdc-sp-flash{0%,100%{box-shadow:0 0 0 0 rgba(229,72,77,0)}50%{box-shadow:0 0 0 5px rgba(229,72,77,.35)}}' +
      /* the approve buttons look unavailable while the combination is wrong */
      '.modal-foot button[data-sb-standblock]{opacity:.55;cursor:not-allowed}';
    document.head.appendChild(st);
  }

  var note = null, noteSig = '';

  function render(opts) {
    var row = document.querySelector('.sbdc-addon[data-key="' + STAND + '"]');
    if (!row) return;
    css();
    if (!note) note = document.createElement('div');
    note.id = NOTE_ID;
    note.setAttribute('role', 'alert');

    var sig = opts.map(function (o) { return o.id; }).join(',');
    if (sig !== noteSig || !note.firstChild) {
      noteSig = sig;
      note.innerHTML = '';
      var h = document.createElement('b');
      h.textContent = 'A banner stand needs pole pockets';
      var p = document.createElement('div');
      p.textContent = 'The stand holds your backdrop by its pole pockets, so grommets or hem won’t work with it. ' +
        'Choose a pole pocket finishing below, or untick the banner stand to keep your current finishing.';
      var btns = document.createElement('div');
      btns.className = 'sp-row';
      opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = 'Switch to ' + o.label;
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var live = pocketOptions().filter(function (x) { return x.id === o.id; })[0];
          if (live && live.btn) live.btn.click();   /* the card's own handler does the work */
          setTimeout(tick, 150);
        });
        btns.appendChild(b);
      });
      note.appendChild(h);
      note.appendChild(p);
      note.appendChild(btns);
    }
    if (note.parentNode !== row || row.lastElementChild !== note) row.appendChild(note);
  }

  function clear() {
    if (note && note.parentNode) note.parentNode.removeChild(note);
  }

  function flash() {
    if (!note || !note.parentNode) return;
    try { note.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    note.classList.remove('sp-flash');
    void note.offsetWidth;
    note.classList.add('sp-flash');
  }

  /* ---- the approve buttons ---------------------------------------------- */

  /* Every button in the proof footer except the plain ones (Download print
     file, Keep editing - both .btn-ghost). Only in the modal that carries the
     add-on section, so no other dialog's footer is touched. */
  function isApprove(el) {
    var b = el && el.closest ? el.closest('.modal-foot button') : null;
    if (!b || b.classList.contains('btn-ghost')) return null;
    var modal = b.closest('.modal');
    if (!modal || !modal.querySelector('.sbdc-addons')) return null;
    return b;
  }

  function markButtons(bad) {
    var bs = document.querySelectorAll('.modal .modal-foot button');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      if (b.classList.contains('btn-ghost')) continue;
      if (bad) { if (!b.hasAttribute('data-sb-standblock')) b.setAttribute('data-sb-standblock', '1'); }
      else if (b.hasAttribute('data-sb-standblock')) b.removeAttribute('data-sb-standblock');
    }
  }

  /* Capture phase on window: runs before React's listener on #root, so a
     stopped click never reaches the approve handler. */
  function guard(e) {
    if (!isApprove(e.target)) return;
    var c = check();
    if (!c.bad) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    info.blocked++;
    render(c.opts);
    flash();
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') guard(e);
  }, true);

  /* Second line: the cart call itself.
     Wrapped ONCE. Other files wrap this same function on a timer
     (sb-dc-cartnav.js and friends, each with a flag of its own); re-wrapping
     whenever the current function lacks our flag would make two such files
     wrap each other every tick and grow the chain forever. The flags already
     on the function are copied onto ours, so nobody else re-wraps either.
     The capture-phase click guard above is the real stop; this is backup. */
  var addWrapped = false;
  function wrapAdd() {
    if (addWrapped) return;
    var f = window.__dcAddToCart;
    if (typeof f !== 'function' || f.__sbStandPocket) return;
    addWrapped = true;
    var w = function () {
      var c = check();
      if (c.bad) {
        info.refusedAdd++;
        render(c.opts);
        flash();
        return Promise.resolve(false);
      }
      return f.apply(this, arguments);
    };
    for (var k in f) { try { if (Object.prototype.hasOwnProperty.call(f, k)) w[k] = f[k]; } catch (e) {} }
    w.__sbStandPocket = true;
    window.__dcAddToCart = w;
  }

  /* ---- loop ------------------------------------------------------------- */

  function tick() {
    wrapAdd();
    if (!document.querySelector('.sbdc-addons')) { clear(); return; }
    var c = check();
    if (c.bad) render(c.opts); else clear();
    markButtons(c.bad);
  }

  var t = setInterval(function () { try { tick(); } catch (e) {} }, 300);
  addEventListener('pagehide', function () { clearInterval(t); });
})();
